import React, { useState } from "react";

interface InputFieldProps {
  name: string;
  type: string;
  labelText: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  error?: string;
  isRequired?: boolean;
}

const index = ({
  name,
  labelText,
  className,
  labelClassName,
  inputClassName,
  placeholder,
  onChange,
  onBlur,
  value,
  error,
  type,
  isRequired,
}: InputFieldProps) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div className={`flex flex-col gap-[6px] w-full ${className}`}>
      {labelText && (
        <label
          htmlFor={name}
          className={`font-satoshi font-medium text-sm ${isFocused ? "text-blueShades-4" : "text-ashShade-16"} ${labelClassName}`}
        >
          {labelText} {isRequired && <span className='text-ERROR'>*</span>}
        </label>
      )}
      <div className='relative w-full'>
        <input
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          name={name}
          type={type}
          className={`border ${isFocused ? "border-[1.5px] border-blueShades-6 outline outline-[3px] outline-[#D8E9F080]" : error ? "border-[1.5px] border-ERROR outline outline-3px outline-[#FFE5E5]" : "border-blueShades-2"}  rounded-md px-3 py-2 text-sm text-ashShade-16 w-full ${inputClassName} `}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
        {error && (
          <span className='absolute left-0 top-full text-ERROR text-[13px] mb-4'>
            {error}
          </span>
        )}
      </div>
    </div>
  );
};

export default index;
